import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { QuickApplyApiService } from "../quick-apply-api.service";
import {TalentHappyPathAuthApiService} from "../../shared/service/talent-happy-path-auth-api.service";
import { QuickApplyWorkflowService } from "../quick-apply-workflow.service";

@Component({
  selector: 'app-quick-apply-otp',
  standalone: false,
  templateUrl: './quick-apply-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './quick-apply-password.component.scss'
})
export class QuickApplyPasswordComponent implements OnInit {

  passwordForm: FormGroup;
  userEnteredEmail: String = '';
  hidePassword: boolean = true;

  constructor(
    private talentHappyPathDataService: TalentHappyPathDataService,
    private authAPIService : TalentHappyPathAuthApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private workflowService: QuickApplyWorkflowService
  ) {}

  ngOnInit(): void {
    this.userEnteredEmail = this.talentHappyPathDataService.talent.email;
    this.passwordForm = new FormGroup({
      password: new FormControl(
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(50)
        ]
      ),
    });
  }

  continue(form: FormGroup): void {
    this.authAPIService.login({ email: this.userEnteredEmail, password: form.value.password, existingUser: true, credentialType: 'password' }).subscribe(
        async data => {
          if (data) {
            await this.workflowService.navigateToState('submit', {} , { relativeTo: this.activatedRoute.parent, skipLocationChange: true });
          }
        }, error => {
          if (error.status === 401) {
            this.passwordForm.controls['password'].setErrors({invalid: true});
          }
        }
    )
  }

  async back() {
    await this.workflowService.navigateToState('start', {} , { relativeTo: this.activatedRoute.parent });
  }

}
